import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS, ReactTable } from "components";
import { PAGE_SIZE } from "utils/common";
import { formatDate } from "utils/dateHelperFunctions";

import type { DealerDMS, DealerLocation } from "models";

type DmsLocationsTableProps = {
  dealer: DealerDMS;
  locations?: DealerLocation[];
  onSelectLocation: (location: DealerLocation) => void;
  onSelectLocationDealer: (dealer: DealerDMS) => void;
};

const columnHelper = createColumnHelper<DealerLocation>();

export const DMSv3LocationsTable = ({ dealer, locations = [], onSelectLocation, onSelectLocationDealer }: DmsLocationsTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "location",
        header: () => <span className="no-wrap-text">{t("v8_location", "Location")}</span>,
        size: 100,
        cell: ({ row: { original } }) => <span className="no-wrap-text">{original.name}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "last_webhook_received_at",
        header: () => <span className="no-wrap-text">{t("v8_last_webhook_received_at", "Last Webhook Received At")}</span>,
        size: 200,
        cell: ({ row: { original } }) => (
          <span className="no-wrap-text">{formatDate(original.last_webhook_received_at, DATE_FORMATS_FNS.dateMonthYearTimeWithSeconds)} </span>
        )
      })
    ],
    [t, locations]
  );

  return (
    <ReactTable
      columns={columns}
      data={locations}
      pageSize={PAGE_SIZE.PageSize25}
      onRowClick={location => {
        onSelectLocation(location);
        onSelectLocationDealer(dealer);
      }}
    />
  );
};
